'use client';

import { useOrderParam } from '@eliadmin/core/src/components/dlz/account/account-pages';
import { OrderDetail } from '@eliadmin/core/src/components/dlz/account/orders/order-detail';
import { OrdersList } from '@eliadmin/core/src/components/dlz/account/orders/orders-list';

/**
 * „Moje objednávky“ (Figma 60323:19774) or, with `?objednavka=…`, „Detail objednávky“ (Figma
 * 60324:20208). The root is the size container: the layouts follow the width of the account column
 * (343 px on phones … 509 px beside the navigation at 1024 … 877 px at 1728), the spacing and type
 * tokens the viewport like everywhere else.
 */
export function OrdersView() {
  const identifier = useOrderParam();

  return (
    <div className="@container">
      {identifier ? <OrderDetail key={identifier} identifier={identifier} /> : <OrdersList />}
    </div>
  );
}
